import SiteCategoriesMainPage from './main';
import SiteCategoryEdit from './edit';
import SingleSiteCategory from './singleCategory';
const routes = [
  {
    path: '/*',
    Component: SiteCategoriesMainPage,
    props: {},
  },
  {
    path: '/:id/edit',
    Component: SiteCategoryEdit,
    props: {},
  },
  {
    path: '/:id',
    Component: SingleSiteCategory,
    props: {},
  },
  {
    path: '/new',
    Component: SiteCategoryEdit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
